import React, { FC, memo } from 'react';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from 'vibo-ui/Button';

import { getNextSectionId } from './constants';
import { useEvent } from 'components/context/EventContext';

import { IconmoonFont } from 'vibo-ui/Icon';
import { NextSectionButtonProps } from './interfaces';

import useStyles from './style';

const NextSectionButton: FC<NextSectionButtonProps> = ({ sections, section }) => {
  const classes = useStyles();

  const navigate = useNavigate();
  const location = useLocation();

  const { timelineRoute } = useEvent();

  const isLast = sections.at(-1)?._id === section._id;

  return (
    <Button
      onClick={() => {
        const nextSectionId = getNextSectionId(sections, section);

        if (nextSectionId) {
          navigate({
            pathname: `${timelineRoute}/${nextSectionId}`,
            search: location.search,
          });

          document.getElementById(nextSectionId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      }}
      prefixIcon={IconmoonFont[isLast ? 'caretUp-16' : 'caretDown-16']}
      className={classNames(classes.nextSectionButton, 'content-fade-in ready _3')}
      size="lg"
      key={`timeline-next-btn-${section._id}`}
    >
      {isLast ? 'To the top' : 'Next section'}
    </Button>
  );
};

export default memo(NextSectionButton);
